<app-header  [dir]="dir"/>

<section class="checkout-area ptb-100" [dir]="dir">
  <div class="container">
  
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="billing-details">
            <h3 class="title">
              {{ "translations.Billing_Details" | translate }}
            </h3>

            <div class="row">
              <div class="col-lg-12 col-md-6">
                <div class="form-group">
                  <label>
                    {{ "translations.name" | translate }}
                    <span class="required">*</span>
                  </label>
                  <div class="select-box">
                    <input type="text"
                           class="form-control"
                           required
                           #clientName="ngModel"
                           name="clientName"
                           [(ngModel)]="mainForm.clientName"
                           (ngModelChange)="onSenderChange()" />
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-md-6">
                <form #f="ngForm" [formGroup]="phoneForm">
                  <div class="form-group">
                    <label>
                      {{ "translations.phone" | translate }}
                      <span class="required">*</span>
                    </label>

                    <ngx-intl-tel-input [cssClass]="'form-control fullW'"
                                        dir="ltr" id="phoneID"
                                        [preferredCountries]="preferredCountries"
                                        [enableAutoCountrySelect]="true"
                                        [enablePlaceholder]="true"
                                        [searchCountryFlag]="true"
                                        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                        [selectFirstCountry]="false"
                                        [selectedCountryISO]="CountryISO.Oman"
                                        [maxLength]="15"
                                        [phoneValidation]="true"
                                        [separateDialCode]="separateDialCode"
                                        [numberFormat]="PhoneNumberFormat.National"
                                        [onlyCountries]="gulfCountries"
                                        (countryChange)="onCountryChange($event)"
                                        name="phone" formControlName="phone">
                    </ngx-intl-tel-input>


                  </div>
                  </form>
              </div>

              <div class="col-lg-12 col-md-6">
                <div class="form-group mb-3">
                  <label>
                    {{ "translations.Delivery_Method" | translate }}<span class="required">*</span>
                  </label>

                  <select [dir]="Direction"
                          class="form-control form-select"
                          #deliveryMethod="ngModel"
                          name="deliveryMethod"
                          [(ngModel)]="mainForm.deliveryMethod"
                          [value]="mainForm.deliveryMethod"
                          style="padding-top: 5px"
                          (change)="onDeliveryMethod()">
                    <option value="Receive from Store">
                      {{ "translations.Receive_from_Store" | translate }}
                    </option>
                    <option value="Delivery to Client">
                      {{ "translations.Delivery_To_Home" | translate }}
                    </option>
                    <option value="Receive from Delivery Company">
                      {{ "translations.Delivery_by_Delivery_Company" | translate }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-lg-12 col-md-6" *ngIf="isAddressDelivery1">
                <div class="form-group">
                  <label>
                    {{
 addressDeliveryName1
                    }}<span class="required">*</span>
                  </label>
                  <div class="select-box">
                    <select class="form-control form-select"
                            [dir]="Direction"
                            #deliveryMethod1="ngModel"
                            name="deliveryMethod1"
                            [(ngModel)]="addressDeliveryValue1"
                            style="padding-top: 5px"
                            (change)="onAddressDelivery1()">
                      <option *ngFor="let option of addressDeliveryData1"
                              [value]="option.inDeliveryAddressID">
                        <ng-template *ngIf="
                            SelectedLanguage == 'ar';
                            then addressAr1;
                            else addressEn1
                          ">
                        </ng-template>
                        <ng-template #addressAr1>
                          {{ option.nameAr }}
                        </ng-template>
                        <ng-template #addressEn1>
                          {{ option.nameEn }}
                        </ng-template>
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-md-6" *ngIf="isAddressDelivery2">
                <div class="form-group">
                  <label>
                    {{ addressDeliveryName2 }}<span class="required">*</span>
                  </label>
                  <div class="select-box">
                    <select class="form-control form-select"
                            [dir]="Direction"
                            #deliveryMethod2="ngModel"
                            name="deliveryMethod2"
                            [(ngModel)]="addressDeliveryValue2"
                            style="padding-top: 5px"
                            (change)="onAddressDelivery2()">
                      <option *ngFor="let option of addressDeliveryData2"
                              [value]="option.inDeliveryAddressID">
                        <ng-template *ngIf="
                            SelectedLanguage == 'ar';
                            then addressAr2;
                            else addressEn2
                          ">
                        </ng-template>
                        <ng-template #addressAr2>
                          {{
                          option.nameAr
                          }}
                        </ng-template>
                        <ng-template #addressEn2>
                          {{
                          option.nameEn
                          }}
                        </ng-template>
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-md-6" *ngIf="isAddressDelivery3">
                <div class="form-group">
                  <label>
                    {{
 addressDeliveryName3
                    }}<span class="required">*</span>
                  </label>
                  <div class="select-box">
                    <select class="form-control form-select"
                            [dir]="Direction"
                            #deliveryMethod3="ngModel"
                            name="deliveryMethod3"
                            [(ngModel)]="addressDeliveryValue3"
                            style="padding-top: 5px"
                            (change)="onAddressDelivery3()">
                      <option *ngFor="let option of addressDeliveryData3"
                              [value]="option.inDeliveryAddressID">
                        <ng-template *ngIf="
                            SelectedLanguage == 'ar';
                            then addressAr3;
                            else addressEn3
                          ">
                        </ng-template>
                        <ng-template #addressAr3>
                          {{  option.nameAr  }}
                        </ng-template>
                        <ng-template #addressEn3>
                          {{ option.nameEn  }}
                        </ng-template>
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-md-6" *ngIf="isAddressDelivery4">
                <div class="form-group">
                  <label>
                    {{ addressDeliveryName4  }}<span class="required">*</span>
                  </label>
                  <div class="select-box">
                    <select class="form-control form-select"
                            [dir]="Direction"
                            #deliveryMethod4="ngModel"
                            name="deliveryMethod4"
                            [(ngModel)]="addressDeliveryValue4"
                            style="padding-top: 5px"
                            (change)="onAddressDelivery4()">
                      <option *ngFor="let option of addressDeliveryData4"
                              [value]="option.inDeliveryAddressID">
                        <ng-template *ngIf="
                            SelectedLanguage == 'ar';
                            then addressAr4;
                            else addressEn4
                          ">
                        </ng-template>
                        <ng-template #addressAr4>
                          {{ option.nameAr  }}
                        </ng-template>
                        <ng-template #addressEn4>
                          {{ option.nameEn  }}
                        </ng-template>
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-md-6" *ngIf="isAddressDelivery5">
                <div class="form-group">
                  <label>
                    {{ addressDeliveryName5  }}<span class="required">*</span>
                  </label>
                  <div class="select-box">
                    <select class="form-control form-select"
                            [dir]="Direction"
                            #deliveryMethod5="ngModel"
                            name="deliveryMethod5"
                            [(ngModel)]="addressDeliveryValue5"
                            style="padding-top: 5px"
                            (change)="onAddressDelivery5()">
                      <option *ngFor="let option of addressDeliveryData5"
                              [value]="option.inDeliveryAddressID">
                        <ng-template *ngIf="
                            SelectedLanguage == 'ar';
                            then addressAr5;
                            else addressEn5
                          ">
                        </ng-template>
                        <ng-template #addressAr5>
                          {{
                          option.nameAr
                          }}
                        </ng-template>
                        <ng-template #addressEn5>
                          {{
                          option.nameEn
                          }}
                        </ng-template>
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-md-6">
                <div class="form-group">
                  <label>
                    {{ "translations.AreaVillage" | translate }}
                    <span class="required">*</span>
                  </label>
                  <div class="select-box">
                    <input type="text"
                           class="form-control"
                           required
                           #address="ngModel"
                           name="address"
                           [(ngModel)]="mainForm.address" />
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-md-6" *ngIf="addressDeliveryValue1 != 0 && addressDeliveryValue1 != 1 && addressDeliveryValue1 != 120">
                <div class="form-group">
                  <label>
                    {{ "translations.Civil_ID" | translate }}
                    <span class="required">*</span>
                  </label>
                  <div class="select-box">
                    <input type="text"
                           class="form-control"
                           required
                           #otherPhoneNo="ngModel"
                           name="otherPhoneNo"
                           [(ngModel)]="mainForm.otherPhoneNo" />
                  </div>
                </div>
              </div>

              <!--<div class="col-lg-12 col-md-6">
    <div class="form-group">
      <div class="select-box">
        <div class="form-group">
          <label>
            {{"translations.Message_in_the_gift" | translate }}
          </label>
          <textarea #attachmentTXT="ngModel" name="attachmentTXT" [(ngModel)]="mainForm.attachmentTXT"
                    cols="30"
                    rows="5"
                    placeholder=""
                    class="form-control"></textarea>
        </div>
      </div>
    </div>
  </div>-->

              <div class="col-lg-12 col-md-6">
                <div class="form-group">
                  <div class="select-box">
                    <div class="form-group">
                      <label>
                        {{"translations.NOTES" | translate }}
                      </label>
                      <textarea #attachmentTXT="ngModel" name="attachmentTXT" [(ngModel)]="mainForm.attachmentTXT"
                                cols="30"
                                rows="5"
                                placeholder=""
                                class="form-control"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12">
          <div class="order-details">
            <h3 class="title">{{ "translations.Your_Order" | translate }}</h3>

            <div class="order-table table-responsive">
              <table class="table table-bordered"  dir="rtl">
                <tbody>
                  <tr *ngFor="let product of products">
                    <td class="product-name">
                      <ng-template *ngIf=" SelectedLanguage == 'ar'; then other_ItemAr; else other_ItemEn ">
                      </ng-template>
                      <ng-template #other_ItemAr>
                        {{ product.nameAr }}
                      </ng-template>
                      <ng-template #other_ItemEn>
                        {{ product.name }}
                      </ng-template>
                    </td>
                    <td class="product-total">
                      <span class="subtotal-amount">
                        {{
                        ( product.cartQuantity * ((product.saleTaxPercentage / 100) * product.salesPrice + product.salesPrice) ).toFixed(3)
                        }}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td class="order-subtotal">
                      <span>
                        {{ "translations.Cart_Subtotal" | translate }}
                      </span>
                      <br />
                      <small class="small">
                        *{{ "translations.Including_VAT" | translate }}
                      </small>
                    </td>
                    <td class="order-subtotal-price">
                      <span class="order-subtotal-amount">
                        {{ total | number : "1.3-6" }}
                      </span>
                    </td>
                  </tr>

                  <tr  *ngIf="mainForm.totalTax! > 0">
                    <td class="order-subtotal">
                      <span>{{ "translations.VAT" | translate }}</span>
                    </td>
                    <td class="order-subtotal-price">
                      <span class="order-subtotal-amount">
                        {{  this.mainForm.totalTax | number : "1.3-6"  }}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td class="order-subtotal">
                      <span>
                        {{  "translations.Promotion_Code" | translate }}
                      </span>
                    </td>
                    <td class="order-subtotal-price">
                      <div class="input-group mb-3" dir="ltr">
                        <button type="submit"
                                class="btn btn-outline-secondary"
                                (click)="onPromotionCode()"
                                [hidden]="isDisabledVoucher">

                          <fa-icon [icon]="faSearch"></fa-icon>

                        </button>

                        <input type="text"
                               class="form-control"
                               #promotionCode="ngModel" name="promotionCode" [(ngModel)]="mainForm.promotionCode" [disabled]="isDisabledVoucher" />


                      </div>
                    </td>
                  </tr>

                  <tr *ngIf="discount > 0">
                    <td class="order-subtotal">
                      <span>{{ "translations.Discount" | translate }}</span>
                    </td>
                    <td class="order-subtotal-price">
                      <span class="order-subtotal-amount">
                        {{ discount | number : "1.3-6" }}
                      </span>
                    </td>
                  </tr>

                  <tr *ngIf="mainForm.serviceCharge! > 0">
                    <td class="order-shipping">
                      <span>{{ "translations.Delivery" | translate }}</span>
                    </td>
                    <td class="shipping-price">
                      <span>
                        {{ mainForm.serviceCharge | number : "1.3-6" }}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td class="total-price">
                      <span>{{ "translations.Order_Total" | translate }}</span>
                    </td>
                    <td class="product-subtotal">
                      <span class="subtotal-amount">
                        {{ mainForm.amount | number : "1.3-6" }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="payment-box">
              <div class="payment-method">
                <input type="checkbox"
                       class="form-check-input"
                       #orderNo
                       name="orderNo" />&nbsp;
                <label for="ServicesTerms">
                  {{ "translations.I_have_read_and_agree_to_the_website"| translate }}
                  <a target="_blank" [routerLink]="['/terms']">
                    {{  "translations.Terms_and_Conditions" | translate  }}
                  </a>*
                </label>

                <p>
                  {{'translations.OTPTXT' | translate }}

                </p>
              </div>
              <button type="submit"
                      class="default-btn"
                      (click)="onOrder(orderNo.checked)">
                {{ "translations.Place_Order" | translate }}
              </button>
              <br />
              <br />
              <img src="../../../../assets/img/Payment.jpg"
                   style="max-width: 200px"
                   class="align-content-center" />
            </div>
          </div>
        </div>
      </div>

  </div>
</section>

<app-footer />
